/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-use-before-define */
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Box,
  ListItem, ListItemIcon, ListItemText, Typography,
  Grid,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dashboard, Person, Store, ShoppingCart, ListAlt, MenuBook,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { ItemModel } from '../../../pages/models';
import { LoginStore } from '../../../services/zustandProvider';

const boxSx = {
  display: 'inline-grid',
  height: '100%',
  width: '100%',
  justifyContent: 'end',
  justifyItems: 'end',
  alignItems: 'end',
  alignContent: 'space-between',
};

const buttonSx = {
  height: 100,
  width: '16% !important',
  minWidth: 120,
  maxWidth: '200px',
  marginRight: '3px',
  marginTop: '0px !important',
  // backgroundColor: '#d5d5d5 !important',
  display: 'block',
  WebkitTransform: 'skew(-5deg)',
  MozTransform: 'skew(-5deg)',
  OTransform: 'skew(-5deg)',
  alignItems: 'center',
  padding: '10px !important',
  color: 'white',
};

const buttonSxNone = {
  height: 100,
  width: '16% !important',
  minWidth: 120,
  maxWidth: '200px',
  marginRight: '3px',
  marginTop: '0px !important',
  backgroundColor: '#bdbdbd !important',
  display: 'block',
  WebkitTransform: 'skew(-5deg)',
  MozTransform: 'skew(-5deg)',
  OTransform: 'skew(-5deg)',
  alignItems: 'center',
  padding: '10px !important',
  color: 'white',
};

const textSx = {
  WebkitTransform: 'skew(5deg) !important',
  MozTransform: 'skew(5deg) !important',
  // fontSize: '2vw',
  // color: 'white',
};

const iconSx = {
  WebkitTransform: 'skew(5deg) !important',
  MozTransform: 'skew(5deg) !important',
  justifyContent: 'flex-end',
  color: 'white',
  fontSize: 50,
};

const FontSx = styled('div')(({ theme }) => ({
  fontSize: '110%',
  [theme.breakpoints.down('sm')]: { fontSize: '110%' },
}));

interface _item {
    router: string;
    icon: any;
    name: string;
}

export default function Item({ router, icon, name }: _item) {
  const location = useLocation();
  const { CadastroFinalizado, userAtivo } = LoginStore();
  const checkIsActive = (url:string) => {
    const arrayPath = location.pathname.split(/[/]/);
    const current = arrayPath[arrayPath.length - 1];
    // if (current === url) {
    //  return true;
    // }
    if (current !== 'Cadastro' && url === 'Dash') {
      return true;
    } if (current === 'Cadastro' && url === 'Cadastro') {
      return true;
    }
    return false;
  };
  function checkUser() {
    if (userAtivo?.confirmarDPO !== 'Sim' || userAtivo?.confirmarEmail !== 'Sim') {
      return true;
    }
    return false;
  }
  return (
    <ListItem
      sx={checkIsActive(router) ? buttonSx : buttonSxNone}
      button
      selected={checkIsActive(router)}
      component={Link}
      to={`/${router}`}
      disabled={checkUser()}
    >
      <Box sx={boxSx}>
        <ListItemIcon sx={iconSx}>
          { icon }
        </ListItemIcon>
        <ListItemText sx={textSx}><Typography sx={{ fontWeight: 'bold' }}>{name}</Typography></ListItemText>
      </Box>

    </ListItem>
  // <>
  //  <div>teste</div>
  // </>
  );
}
